/**
 * WebView PostMessage Types
 */

export enum WebViewMessageType {
  // Incoming messages
  SET_EXTERNAL_PROPS = 'setExternalProps',
  UPDATE_AUTH = 'updateAuth',
  UPDATE_TEST_CONFIG = 'updateTestConfig',
  REQUEST_EXAM_DATA = 'REQUEST_EXAM_DATA',
  
  // Outgoing messages
  READY = 'webviewReady',
  AUTH_SUCCESS = 'authSuccess',
  AUTH_ERROR = 'authError',
  TEST_COMPLETE = 'testComplete',
  ANSWER_CHANGE = 'answerChange',
  RECORDING_COMPLETE = 'recordingComplete',
  ERROR = 'error',
  EXAM_DATA_LOADED = 'EXAM_DATA_LOADED',
  SINCAPP_EXAM_DATA = 'SINCAPP_EXAM_DATA',
  EXIT_REQUESTED = 'exitRequested',
  TEST_COMPLETED = 'testCompleted',
  TEST_NOT_LOADED = 'testNotLoaded',
}

export interface WebViewMessage<T = any> {
  type: WebViewMessageType;
  data?: T;
  timestamp: number;
  origin?: string;
}

export interface WebViewMessageHandlers {
  [WebViewMessageType.SET_EXTERNAL_PROPS]?: (data: any) => void;
  [WebViewMessageType.UPDATE_AUTH]?: (data: any) => void;
  [WebViewMessageType.UPDATE_TEST_CONFIG]?: (data: any) => void;
  [WebViewMessageType.REQUEST_EXAM_DATA]?: (data: any) => void;
  [WebViewMessageType.READY]?: (data: any) => void;
  [WebViewMessageType.AUTH_SUCCESS]?: (data: any) => void;
  [WebViewMessageType.AUTH_ERROR]?: (data: any) => void;
  [WebViewMessageType.TEST_COMPLETE]?: (data: any) => void;
  [WebViewMessageType.ANSWER_CHANGE]?: (data: any) => void;
  [WebViewMessageType.RECORDING_COMPLETE]?: (data: any) => void;
  [WebViewMessageType.ERROR]?: (data: any) => void;
  [WebViewMessageType.EXAM_DATA_LOADED]?: (data: any) => void;
  [WebViewMessageType.SINCAPP_EXAM_DATA]?: (data: any) => void;
  [WebViewMessageType.EXIT_REQUESTED]?: (data: any) => void;
  [WebViewMessageType.TEST_COMPLETED]?: (data: any) => void;
  [WebViewMessageType.TEST_NOT_LOADED]?: (data: any) => void;
}